'use client';

import { useIntl } from 'react-intl';

import { Chip } from '@packages/shared/src/ui/Chip/Chip';

import type { FilterRangeValue } from '../../types';
import { messages } from '../SelectedFilterValueChip/SelectedFilterValueChip';

export type SelectedFilterRangeChipV2Props = {
  value: FilterRangeValue;
  onDelete: () => void;
};

/**
 * SelectedFilterRangeChipV2 component description displayed in storybook
 * */
export const SelectedFilterRangeChipV2 = ({ value, onDelete }: SelectedFilterRangeChipV2Props) => {
  const { formatMessage } = useIntl();

  const label = `${value.range.join('-')} ${value.unit}`;

  return (
    <Chip
      label={label}
      onDelete={onDelete}
      ariaLabelForDelete={formatMessage(messages.deleteLabel, { name: label })}
      variant="outlined"
    />
  );
};
